import { Component, OnInit } from '@angular/core';
import { UserService } from "@shared/user/user.service";
import { LayoutService } from "@shared/layout/layout.service";
import { ManageStateService } from '@shared/manage-state.service';
import { CookieConfig } from '@util/variable';

@Component({

  selector: 'sa-login-info',
  templateUrl: './login-info.component.html',
})
export class LoginInfoComponent implements OnInit {

  user: any;
  userName: string;
  tk: string;
  image: string;

  constructor(
    private userService: UserService,
    private layoutService: LayoutService,
    private manageStateService: ManageStateService) {
  }

  ngOnInit() {
    this.userService.getLoginInfo().subscribe(user => {
      this.user = user
    })

    this.userName = this.manageStateService.load(CookieConfig.NAME_COOKIE)
    this.tk = this.manageStateService.load(CookieConfig.NVID_COOKIE)
    this.image = this.manageStateService.load(CookieConfig.IMAGE_COOKIE)
  }

  toggleShortcut() {
    this.layoutService.onShortcutToggle()
  }

  onError() {
    this.image = `assets/img/avatars/sunny.png`;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/user/login-info/login-info.component.ts